module.exports = new __parcel__URL__("Project Status Hover.a6f2e4f1.svg").toString();